var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login--page"},[_c('img',{staticClass:"logo--login",attrs:{"src":require("../assets/logo.png")}}),_c('Login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }